<!-- Right Sidebar -->
<div class="right-bar" (clickOutside)="hide()" [exclude]="'.right-bar-toggle'" >
  <div data-simplebar class="h-100" style="background-color: #0f766e !important;">
    <div class="rightbar-title px-3 py-4">
      <a href="javascript:void(0);" class="right-bar-toggle float-end" (click)="hide()">
        <i class="mdi mdi-close noti-icon"></i>
      </a>
      <h5 class="m-0">Settings</h5>
    </div>

    <!-- Settings -->
    <hr class="mt-0" />
    <h6 class="text-center mb-0">Choose Layouts</h6>

    <div class="p-4">
      <div class="mb-2">
        <!--Royal Fabric Light Theme-->
        <img src="assets/images/layouts/layout-1.jpg" class="img-fluid img-thumbnail" alt="">
        <!-- </a> -->
      </div>
      <div class="form-check form-switch mb-3">
        <input class="form-check-input theme-choice" type="checkbox" id="light-mode-switch" [(ngModel)]="isLightModeOn"
          (change)="onLightModeChange()">
        <label class="form-check-label" for="light-mode-switch">Light Mode</label>
      </div>
      <div class="mb-2">
        <!--Royal Fabric Dark Theme-->
        <img src="assets/images/layouts/layout-2.jpg" class="img-fluid img-thumbnail" alt="">
        <!-- </a> -->
      </div>
      <div class="form-check form-switch mb-3">
        <input class="form-check-input theme-choice" type="checkbox" id="dark-mode-switch" [(ngModel)]="isDarkModeOn"
          (change)="onDarkModeChange()">
        <label class="form-check-label" for="dark-mode-switch">Dark Mode</label>
      </div>
    </div>

  </div> <!-- end slimscroll-menu-->
</div>
<!-- /Right-bar -->

<!-- Right bar overlay-->
<div class="rightbar-overlay"></div>